import styled, { css } from 'styled-components'

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 30px;

    > button {
      width: 50%;
    }

    .access-complete-register-button {
      font-size: ${theme.font.sizes.normal};
      margin-top: 20px;
      color: ${theme.colors.darkGray};
      cursor: pointer;
      transition: ${theme.transition.default};
      border: none;
      background: none;

      &:hover {
        filter: brightness(0.9);
      }
    }
  `}
`
